import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import { SFSchema, SFComponent } from '@delon/form';
import {UserLocalViewComponent} from "./view/view.component";
import {UserLocalEditComponent} from "./edit/edit.component";
import {NzMessageService, NzTreeNode, NzFormatEmitEvent} from "ng-zorro-antd";
import {UserService, DeptService} from "@ecip/service";
import {UserLocalRoleComponent} from "./role/user.role.component";
import {UserLocalAppComponent} from "./app/user.app.component";

@Component({
  selector: 'app-user-local',
  templateUrl: './local.component.html',
  styleUrls: ['./local.component.less']
})
export class UserLocalComponent implements OnInit {
  url = `api/v1/sysrUser/list`;
  searchSchema: SFSchema = {
    properties: {
      id: {
        type: 'string',
        title: 'ç¼å·'
      },
      username: {
        type: 'string',
        title: 'è´¦å·'
      },
      realName: {
        type: 'string',
        title: 'å§å'
      }
    }
  };


  @ViewChild('st') st: STComponent;
  columns: STColumn[] = [
    // { title: 'ç¼å·', index: 'id' },
    { title: 'è´¦å·', index: 'username' },
    { title: 'å§å', index: 'realName' },
    { title: 'æ§å«', index: 'sexText' },
    { title: 'é®ç®±', index: 'email' },
    { title: 'åå»ºæ¶é´', type: 'date', index: 'createTime'},
    {
      title: 'æä½',
      width: '100px',
      buttons: [
        { text: 'å é¤', type: 'del', click: (item: any) => {
            //å é¤
            this.userService.deleteById(item.id).subscribe(res => {
              this.msgSrv.success('å é¤æå');
              this.st.reload();
            });
          },
          acl: { ability: ['local:remove'] }
        },
        {
          text: '',
          children: [
            { text: 'æ¥ç', type: 'static', component: UserLocalViewComponent, click: 'reload', acl: { ability: ['local:view'] } },
            { text: 'ç¼è¾', type: 'static', component: UserLocalEditComponent, click: 'reload', acl: { ability: ['local:edit'] } },
            { text: 'è§è²', type: 'static', component: UserLocalRoleComponent, click: 'reload', acl: { ability: ['role:choose'] } },
            { text: 'ç³»ç»', type: 'static', component: UserLocalAppComponent, click: 'reload', acl: { ability: ['system:choose'] }},
            { text: 'éç½®å¯ç ', pop: true, popTitle: 'ä½ ç¡®è®¤è¦éç½®å¯ç å', click: (item: any) => {
                //éç½®å¯ç 
                this.userService.resetPasswordById(item.id).subscribe(res => {
                  this.msgSrv.success('éç½®å¯ç æå');
                  this.st.reload();
                });
              },
              acl: { ability: ['password:reset'] }
            }
          ],
        },
      ]
      , index: 'operate'
    }
  ];

  depts = [];
  deptId;

  constructor( private modal: ModalHelper,
               private msgSrv: NzMessageService,
               public deptService: DeptService,
               public userService: UserService) { }

  ngOnInit() {
    //è·åç»ç»æºæ
    this.deptService.getList().subscribe((res: any) => {
      let root = [];
      res.forEach(item => {
        let node = new NzTreeNode({
          key: item.id,
          title: item.shortName,
          children: item.children,
          isLeaf: !item.children
        });
        root.push(node);
      });
      this.depts = root;
    });
  }

  add() {
    this.modal
      .createStatic(UserLocalEditComponent, { i: { }, deptId:  this.deptId})
      .subscribe(() => this.st.reload());
  }


  deptClick(e: NzFormatEmitEvent, st: STComponent): void {
    this.deptId = e.node.key;
    st.reload({deptId: this.deptId});
  }

}
